module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Learning about Equipment"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e125",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Learning about Equipment")])])])])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e128",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Heavy-Duty Electric Stand Mixer with a Wire Whisk or Flat Beater ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e128",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("It is best to use a heavy-duty stand mixer to make homemade marshmallows. Even the most\n        powerful hand mixers might overheat during the beating process, and many hand-mixer motors\n        will burn out when used to beat the thick, sticky batter. A few flavors require 15 or more\n        minutes beating time, which is difficult to do with a hand mixer. Use the wire whisk\n        attachment if you have one for both marshmallows and marshmallow fluff. If you don’t have a\n        wire whisk for your stand mixer, you can use a paddle attachment. Your marshmallows will\n        still be wonderful, just not quite as fluffy. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e132",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Candy Thermometer ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e132",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Standard instant-read and meat thermometers don’t have the temperature range necessary to\n        track the heat of the syrup as it rises to the specific temperature required for marshmallow\n        making. Use a candy thermometer for best results. The least expensive is a mercury\n        thermometer encased with a metal clip that attaches to the saucepan to keep it upright.\n        Another style, more expensive but much easier to read, is a mercury thermometer attached to\n        a flat metal casing with a metal clip to hold it upright in the pan. The most accurate, but\n        more expensive, is a battery-powered digital thermometer that registers the temperature on\n        an LCD display. It can alert you with a beep when the correct temperature has been reached,\n        in case you become distracted. It can be used for a number of cooking projects, so buying\n        one is a good investment. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e136",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Heavy Saucepans ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e136",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("A 4-quart saucepan with a heavy bottom and sides should be used for making most of the\n        marshmallow recipes from this book, and the same in a 2-quart size for most of the fluff\n        recipes. If the pan is smaller than specified in the recipe, the cooked base might boil\n        over, and if it’s too large, the base might not be high enough in the pan to register its\n        temperature on the candy thermometer. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e140",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Flexible Heatproof Spatula ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e140",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Having one or more heatproof silicone spatulas helps in stirring the hot base, scraping\n        the sticky marshmallow batter out of the mixer bowl, and smoothing the top of the\n        marshmallow slab. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e144",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Measuring Cups and Spoons ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e144",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("You’ll need a set of dry measuring cups, at least one 2-cup liquid measuring cup, and a\n        set of measuring spoons to make recipes from this book. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e148",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Pan for Molding the Marshmallows ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e148",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Unless otherwise indicated, the marshmallow batters in this book will fit into a 9 x\n        13-inch rectangular baking pan, or an 11 x 15-inch jelly roll/cookie sheet (the kind with\n        sides). If you don’t have either of those pans, don’t despair. You can spread the batter\n        into any pan or mold large enough to hold it; more than one pan or mold; or onto any flat,\n        smooth, prepared surface, to whatever thickness you like. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e148",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("The batter is extremely sticky, so any pan or surface you use for the marshmallow batter\n        should be either dusted generously with the coating mixture or very lightly oiled. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e154",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Marshmallow Cutting Tools ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e154",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Marshmallows can be cut using a lightly oiled pizza wheel, chef’s knife, pair of kitchen\n        scissors, or cheese wire. (You can make your own cheese wire by wrapping the ends of a thin,\n        smooth, rustproof wire or filament around pencils. The wire will cut through the\n        marshmallow, and the pencils serve as handles.) I prefer using a pizza wheel, which zips\n        right through the marshmallow. The one I use is made by All-Clad, and is a sturdy stainless\n        steel instrument with a large wheel that gives me good control while cutting the\n        marshmallows quickly and with ease. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e158",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Kitchen Scale ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e158",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("You can certainly manage without a kitchen scale; however, if you can afford one, they are\n        easy to use and reduce the need for measuring cups, so there are fewer dishes to wash. There\n        is a scale on the market, the Pana made by Escali, which converts the weight of ingredients\n        into cups or tablespoons. ")])]), _c('h3', [_c('a', {
    attrs: {
      "id": "d0e162",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Equipment for Making Fancy Marshmallows ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e162",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("In addition to the equipment listed above, you might want to have an assortment of sharp\n        cookie cutters or a piping bag and tips to make fancier marshmallow shapes and fun projects\n        or gifts. Silicone molds, fancy baking pans, and individual cake pans in special shapes can\n        all be used as marshmallow molds, as long as they are oiled to prevent sticking.")])]), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of cooking candy."
    }
  }, [_c('a', {
    attrs: {
      "id": "d0e162",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of cooking candy.",
      "src": "images/070402_cook_0003001.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f0ea29b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch04.vue
// module id = 75
// module chunks = 0